import React from 'react';
import { ProjectForm } from '../../components/Projects';

const ProjectCreate = () => {
  return (
    <div>
      <h1>Create New Project</h1>
      <ProjectForm />
    </div>
  );
};

export default ProjectCreate;


